import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import Page from 'Views/Page';
import { PAGE_LINK_QUERY_PARAM } from 'Views/Page/Contexts/PageContentContext';
import { NewClientContextProvider } from 'Context/NewClientContext';
import { MessagesStatsContextProvider } from 'Context/MessagesStatsContext';
import { useSurveyStepContext } from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepContext';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import PlannerChat from 'Views/Onboarding/Components/HeaderBar/PlannerChat';
import { useOnboardingContext } from 'Views/Onboarding/Contexts/OnboardingContext';
import OnboardingNavigationPicker from 'Views/Onboarding/Components/HeaderBar/OnboardingNavigationPicker';
import { useOnboardingHeaderContext } from 'Views/Onboarding/Contexts/OnboardingHeaderContext';

const styles = () => ({
});

const WELCOME_STEPS = new Set([
  'investmentProfileWelcome',
]);

function EmbeddedWizardLayout() {
  const history = useHistory();

  const { onClickNext } = useSurveyStepContext();

  const { isHeaderThemeDark, handleSetHeaderThemeLight, handleSetHeaderThemeDark } = useOnboardingHeaderContext();

  const {
    resource,
    onSubmit,
  } = useMetaLayoutContext();

  const { clientResource } = useOnboardingContext();

  const { setHeaderVisibility, showHeader } = useSurveyContext();
  const [originalShowHeader] = useState(showHeader);

  const [selfPageLinkURLParam, setSelfPageLinkURLParam] = useState(null);

  const [isWelcomeStep, setIsWelcomeStep] = useState(false);
  useEffect(() => {
    if (isWelcomeStep && !isHeaderThemeDark) {
      handleSetHeaderThemeDark();
    } else if (isHeaderThemeDark) {
      handleSetHeaderThemeLight();
    }
  }, [isWelcomeStep]);

  // handle mount init
  const [initializing, setInitializing] = useState(true);
  useEffect(() => {
    // hide onboarding step header as wizard step will have its own header
    setHeaderVisibility(false);
    // identify whether to fetch the page link from the URL or from the resource
    const params = new URLSearchParams(history.location.search);
    let pageLink = params.get(PAGE_LINK_QUERY_PARAM);
    if (!pageLink) {
      pageLink = resource.relationship(fr.relationships.wizard.name).link('related').url();
    }
    // add wizard step query param to the URL
    params.set(PAGE_LINK_QUERY_PARAM, pageLink);
    history.replace(`${history.location.pathname}?${params}`);
    setSelfPageLinkURLParam(pageLink);
    setInitializing(false);
    // handle unmount
    return () => {
      // revert header state back
      setHeaderVisibility(originalShowHeader);
      // remove wizard step query param from the URL
      const p = new URLSearchParams(history.location.search);
      p.delete(PAGE_LINK_QUERY_PARAM);
      history.replace(`${history.location.pathname}?${p}`);
    };
  }, []);

  // monitor changes to the wizard step query param
  useEffect(() => {
    const searchParams = new URLSearchParams(history.location.search);
    const pageLink = searchParams.get(PAGE_LINK_QUERY_PARAM);
    if (selfPageLinkURLParam !== pageLink) {
      setSelfPageLinkURLParam(pageLink);

      if (pageLink) {
        const params = (new URL(pageLink)).searchParams;
        const step = params.get('step');
        setIsWelcomeStep(WELCOME_STEPS.has(step));
      }
    }
  }, [history.location.search]);

  // if wizard step query param has been removed from the URL after initializing, we must exit this step by submitting it
  useEffect(() => {
    if (!selfPageLinkURLParam && !initializing) {
      onClickNext(onSubmit);
    }
  }, [selfPageLinkURLParam]);

  if (selfPageLinkURLParam) {
    return (
      <MessagesStatsContextProvider>
        <NewClientContextProvider>
          <Page
            navigationHeaderLeft={<OnboardingNavigationPicker clientResource={clientResource} />}
            navigationHeaderRight={<PlannerChat clientResource={clientResource} />}
          />
        </NewClientContextProvider>
      </MessagesStatsContextProvider>
    );
  }
  return null;
}
EmbeddedWizardLayout.propTypes = {
};
EmbeddedWizardLayout.defaultProps = {
};

export default withStyles(styles)(EmbeddedWizardLayout);
